export const FORM_SECTION_IDS = {
  TX_MONITORING_DROPDOWNS: 'TX_MONITORING_DROPDOWNS',
  D2_MONITORING_DROPDOWNS: 'D2_MONITORING_DROPDOWNS',
  BULLET_POINT: 'BULLET_POINT',
} as const;

export const FORM_PREFIXES = {
  TX_MONITORING: 'tx_monitoring_',
  D2_MONITORING: 'd2_monitoring_',
} as const;

export const QUESTION_ID_PREFIXES = {
  TX_MONITORING: 'TX_MONITORING_',
  D2_MONITORING: 'D2_MONITORING_',
} as const;

// Form display names - what users see
export const FORM_DISPLAY_NAMES = {
  TRANSACTION_MONITORING_FORM: 'Transaction monitoring form',
  D2AS_CONTACT_REVIEW: 'D2AS Contact Review',
  RECIPIENT_REVIEW_FORM: 'Recipient review form',
  OFFROAD_DRIVER_REVIEW_FORM: 'Offroad driver review form',
  NON_DELIVERY_REVIEW_FORM: 'Non-Delivery review form',
  CAP_REVIEW_FORM: 'CAP Review Form',
  DART_ESCALATIONS_FORM: 'DART Escalations Form',
  DART_CONSULTATION_FORM: 'DART Consultation Form',
} as const;

// Form internal IDs - used for draft lookups and internal logic
export const FORM_IDS = {
  TRANSACTION_MONITORING_FORM: 'TRANSACTION_MONITORING_FORM',
  D2_FORM: 'D2_FORM',
} as const;

export const SPECIAL_QUESTION_IDS = {
  TX_MONITORING_CONTACT_REVIEW_FORM_TYPE:
    'TX_MONITORING_CONTACT_REVIEW_FORM_TYPE',
  D2_MONITORING_CONTACT_REVIEW_FORM_TYPE:
    'D2_MONITORING_CONTACT_REVIEW_FORM_TYPE',
} as const;
